import { render, staticRenderFns } from "./PasswordUpdated.vue?vue&type=template&id=dbda0620&"
import script from "./PasswordUpdated.vue?vue&type=script&lang=js&"
export * from "./PasswordUpdated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports